/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface StopWorkerResponse
 */
export interface StopWorkerResponse {
  /**
   *
   * @type {string}
   * @memberof StopWorkerResponse
   */
  status: string;
}

/**
 * Check if a given object implements the StopWorkerResponse interface.
 */
export function instanceOfStopWorkerResponse(
  value: object,
): value is StopWorkerResponse {
  if (!("status" in value) || value["status"] === undefined) return false;
  return true;
}

export function StopWorkerResponseFromJSON(json: any): StopWorkerResponse {
  return StopWorkerResponseFromJSONTyped(json, false);
}

export function StopWorkerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StopWorkerResponse {
  if (json == null) {
    return json;
  }
  return {
    status: json["status"],
  };
}

export function StopWorkerResponseToJSON(json: any): StopWorkerResponse {
  return StopWorkerResponseToJSONTyped(json, false);
}

export function StopWorkerResponseToJSONTyped(
  value?: StopWorkerResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    status: value["status"],
  };
}
